import React from "react";
import styled from "styled-components";

const OuterContainer = styled.div`
  margin: ${(props) => (props.inline ? "10px 30px" : "10px")};
  font-family: "Thasadith";
  color: #333333;
  font-weight: bold;
  font-size: 16px;
  display: ${(props) => (props.inline ? "inline-block" : "block")};
`;

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: ${(props) => props.colors.primary};
  stroke-width: 3px;
`;
// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const CheckboxBorder = styled.div`
display: inline-block;
padding: 3px;
width: 38px
height: 38px;
background: ${(props) => props.colors.secondary};
  margin-right: 10px;
`;
const InnerCheckbox = styled.div`
  display: block;
  width: 26px;
  height: 26px;
  cursor: pointer;
  border-radius: 0px;
  transition: all 150ms;
  border: 3px solid ${(props) => props.colors.primary};

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${(props) => props.colors.secondary};
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;

const Checkbox = ({ label, colors, checked, inline = false, ...props }) => (
  <OuterContainer inline={inline.toString()}>
    <label>
      <CheckboxContainer>
        <HiddenCheckbox checked={checked} {...props} />
        <CheckboxBorder colors={{ ...colors }}>
          <InnerCheckbox checked={checked} colors={{ ...colors }}>
            <Icon viewBox="0 0 24 24" colors={{ ...colors }}>
              <polyline points="20 6 9 17 4 12" />
            </Icon>
          </InnerCheckbox>
        </CheckboxBorder>
      </CheckboxContainer>
      <span style={{ marginLeft: 8, cursor: "pointer" }}>{label}</span>
    </label>
  </OuterContainer>
);

export default Checkbox;
